<template>
  <div class="about">
    <h1>公司简介</h1>

    <!-- <video
      class="video"
      src="https://oss.dayaedu.com/website/daya-reset.mp4"
      controls
      autoplay
    ></video> -->
    <p class="info">大雅乐盟成立于2002年，秉持“和生万物，心为乐本，敦诚敦信，致远致臻”的发展理念，依托独创的音乐课程理念，优秀、敬业的师资队伍和完善的教学管理体系，全力打造国内顶尖的音乐教育品牌。</p>
    <p class="info">随着素质教育的不断深入，各级教育部门强调特色办学，在中小学组建管乐团已成为提升学校音乐教育、发挥学生艺术特长的一个重要途径。大雅乐盟所追求的，不止于为广大音乐爱好者提供更有价值的服务，还将以学校乐团为载体，助力学生熟练掌握一门以上的乐器，同时通过独具特色的各类音乐实践活动，培养学生团结、合作、自信等健康和谐的精神素质。</p>
  </div>
</template>

<style lang="less" scoped>
.about {
  width: 810px;
  padding: 0 101px 40px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.11);
  h1 {
    padding: 20px 0 10px;
    color: #08433f;
    font-size: 25px;
    line-height: 55px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 54px;
  }

  .video {
    width: 810px;
    height: 456px;
    background: #000;
    margin-bottom: 24px;
  }

  p {
    font-size: 16px;
    line-height: 22px;
    text-indent: 32px;
    color: #000;
    opacity: 0.5;
  }
  .info{
    text-indent: 2rem;
    margin-bottom: 10px;
    line-height: 1.8;
  }
}
</style>

<script>
/* eslint-disable */

export default {
  name: "about"
};
</script>
